module.exports = __webpack_public_path__ + "static/img/spot_resource_empty.2888df75.png";